module.exports = __webpack_public_path__ + "static/media/simulator_zh.af6441e7.png";